module.exports = __webpack_public_path__ + "static/media/W_Calendar_06.d1bc5612.png";